import { styled } from "@stitches/react";

export const Box = styled("div", { 
    fontFamily: "system-ui"
});
